import * as React from 'react';

import type { ModulesContextValue } from '../../ModulesProvider.types';

import { ModulesContext } from '../../ModulesProvider';

export function useModules(): ModulesContextValue {
  const context = React.useContext(ModulesContext);

  if (!context) {
    throw new Error('useModules must be used within ModulesProvider');
  }

  return context;
}
